import { legacyApiUrl } from 'helpers/effects'

import { api } from './oauth-api-service'

export default api(legacyApiUrl)
